<script lang="ts">
	import LoadingIcon from "@svg/Loading.svelte";

	export interface Props {
		stopPropagation?: boolean;
		loading?: boolean;
		onclick?: (event: any) => void;
		disabled?: boolean;
		color?: string;
		width?: string;
		borderRadius?: string;
		size?: "btn-md" | "btn-lg" | "btn-sm" | "btn-xl" | "btn-xs";
		variant?: "btn-text" | "btn-contained" | "btn-outlined";
		justify?: "justify-start" | "justify-center" | "justify-end";
		textColor?: string;
		shadow?: boolean;
		css?: string;
		padding?: string;
		type?: "button" | "submit";
		href?: string;
		target?: "_blank";
		loadingText?: string;
	}

	const {
		stopPropagation = true,
		disabled = false,
		width = "w-auto",
		justify = "justify-center",
		size = "btn-md",
		variant = "btn-contained",
		color = "text-primary",
		borderRadius = "rounded-lg",
		shadow = false,
		css,
		padding,
		type = "button",
		href,
		target,
		textColor = "text-white",
		onclick,
		loading = false,
		loadingText = "Laden..."
	}: Props = $props();

	let element = $state(href ? "a" : "button");
</script>

<svelte:element
	this={element}
	{...element === "button" && { type, disabled }}
	{...element === "a" && { href, target }}
	onclick={(event) => {
		if (stopPropagation) {
			event.stopImmediatePropagation();
			event.stopPropagation();
		}

		if (!disabled) {
			onclick?.(event);
		}
	}}
	role={href ? "link" : "button"}
	class="btn {css} {padding
		? padding
		: size} {variant} {color} {width} {borderRadius}
	{shadow &&
		'shadow-custom shadow-black !transition-all focus:translate-y-2 focus:!shadow-transparent'}

	{$$slots['icon-start'] && 'btn-icon-start'}
	{$$slots['icon-end'] && 'btn-icon-end'}
	"
>
	<div class="flex h-full items-center {justify} {textColor}">
		{#if loading}
			<LoadingIcon class="mr-2 w-6 animate-spin fill-white" />
			{loadingText}
		{:else}
			<!-- svelte-ignore slot_element_deprecated -->
			{#if $$slots["icon-start"]}
				<slot name="icon-start" />
			{/if}
			<!-- svelte-ignore slot_element_deprecated -->
			<slot />
			<!-- svelte-ignore slot_element_deprecated -->
			{#if $$slots["icon-end"]}
				<slot name="icon-end" />
			{/if}
		{/if}
	</div>
</svelte:element>
